/**
 * @generated SignedSource<<4f271ca73f2c4950828317e38119fecc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Plan = "FREE" | "PRO" | "PROMO" | "STARTER" | "UP_TO_100" | "UP_TO_15" | "UP_TO_200" | "UP_TO_30" | "UP_TO_5" | "UP_TO_50" | "UP_TO_75" | "UP_TO_INFINITY" | "UP_TO_UNLIMITED" | "YEARLY_UNLIMITED" | "YEARLY_UP_TO_100" | "YEARLY_UP_TO_200" | "YEARLY_UP_TO_50" | "%future added value";
export type CoachSettingsPlanRouteQuery$variables = Record<PropertyKey, never>;
export type CoachSettingsPlanRouteQuery$data = {
  readonly clients: {
    readonly " $fragmentSpreads": FragmentRefs<"SelectClientsDialog_clients">;
  } | null | undefined;
  readonly me: {
    readonly subscription: {
      readonly plan: Plan | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CoachSettingsPlan_user">;
  } | null | undefined;
};
export type CoachSettingsPlanRouteQuery = {
  response: CoachSettingsPlanRouteQuery$data;
  variables: CoachSettingsPlanRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plan",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "noSample",
  "value": true
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 9999
  },
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMMM D, YYYY"
  },
  {
    "kind": "Literal",
    "name": "utc",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachSettingsPlanRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Subscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CoachSettingsPlan_user"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SelectClientsDialog_clients"
          }
        ],
        "storageKey": "clients(first:9999,noSample:true,status:\"ACTIVE\")"
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CoachSettingsPlanRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Subscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "kind": "ScalarField",
                "name": "periodEndDate",
                "storageKey": "periodEndDate(format:\"MMMM D, YYYY\",utc:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancelAtPeriodEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "kind": "ScalarField",
                "name": "canceledAtDate",
                "storageKey": "canceledAtDate(format:\"MMMM D, YYYY\",utc:true)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isImpersonating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "raw",
                "value": true
              }
            ],
            "kind": "ScalarField",
            "name": "trialExpiryDate",
            "storageKey": "trialExpiryDate(raw:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trialExpired",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": "clientsCountNoSample",
            "args": [
              (v1/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "clientsCount",
            "storageKey": "clientsCount(noSample:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAddress",
            "kind": "LinkedField",
            "name": "billingAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "planTier",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "clients(first:9999,noSample:true,status:\"ACTIVE\")"
      }
    ]
  },
  "params": {
    "cacheID": "8b7fc80628c99daaf68d605da5360379",
    "id": null,
    "metadata": {},
    "name": "CoachSettingsPlanRouteQuery",
    "operationKind": "query",
    "text": "query CoachSettingsPlanRouteQuery {\n  me {\n    subscription {\n      plan\n      id\n    }\n    ...CoachSettingsPlan_user\n    id\n  }\n  clients(first: 9999, status: ACTIVE, noSample: true) {\n    ...SelectClientsDialog_clients\n  }\n}\n\nfragment CoachSettingsPlanStatusText_subscription on Subscription {\n  status\n  canceledAtDate(utc: true, format: \"MMMM D, YYYY\")\n  periodEndDate(utc: true, format: \"MMMM D, YYYY\")\n  cancelAtPeriodEnd\n}\n\nfragment CoachSettingsPlanStatusText_user on User {\n  plan\n  trialExpiryDate(raw: true)\n  trialExpired\n}\n\nfragment CoachSettingsPlanTextSubtitle_subscription on Subscription {\n  status\n  canceledAtDate(utc: true, format: \"MMMM D, YYYY\")\n  periodEndDate(utc: true, format: \"MMMM D, YYYY\")\n  cancelAtPeriodEnd\n}\n\nfragment CoachSettingsPlanTextSubtitle_user on User {\n  plan\n  trialExpiryDate(raw: true)\n  trialExpired\n}\n\nfragment CoachSettingsPlan_user on User {\n  isImpersonating\n  trialExpiryDate(raw: true)\n  trialExpired\n  plan\n  clientsCountNoSample: clientsCount(noSample: true)\n  subscription {\n    periodEndDate(utc: true, format: \"MMMM D, YYYY\")\n    cancelAtPeriodEnd\n    status\n    canceledAtDate(utc: true, format: \"MMMM D, YYYY\")\n    ...CoachSettingsPlanTextSubtitle_subscription\n    ...CoachSettingsPlanStatusText_subscription\n    id\n  }\n  billingAddress {\n    ...ManagePlanCard_billingAddress\n    ...ProUpgradeCard_billingAddress\n    id\n  }\n  ...ProUpgradeCard_user\n  ...CoachSettingsPlanTextSubtitle_user\n  ...CoachSettingsPlanStatusText_user\n}\n\nfragment ManagePlanCard_billingAddress on BillingAddress {\n  street\n  city\n  postalCode\n  country\n  ...UpdateBillingAddressDialog_billingAddress\n}\n\nfragment ProUpgradeCard_billingAddress on BillingAddress {\n  street\n  city\n  postalCode\n  country\n}\n\nfragment ProUpgradeCard_user on User {\n  clientsCountNoSample: clientsCount(noSample: true)\n  plan\n  id\n  planTier\n  displayName\n  subscription {\n    status\n    id\n  }\n}\n\nfragment SelectClientsDialog_clients on ClientConnection {\n  edges {\n    node {\n      email\n      displayName\n      id\n    }\n  }\n}\n\nfragment UpdateBillingAddressDialog_billingAddress on BillingAddress {\n  street\n  city\n  postalCode\n  country\n}\n"
  }
};
})();

(node as any).hash = "fcaba7ee754e2ccc6fd4f980edbe9f68";

export default node;
